export default "__VITE_ASSET__DrJygIOp__"